import { BASE_URL } from "../../helpers/config";
import authorizedAxios from "../../helpers/authorizedAxios";
import { showToast } from "../../utils/helpers/ShowToast";
export const SET_PEGAWAIS = "SET_PEGAWAIS";
export const SET_PEGAWAI = "SET_PEGAWAI";
export const SET_PEGAWAIS_LOADING = "SET_PEGAWAIS_LOADING";
export const SET_PEGAWAIS_ERROR = "SET_PEGAWAIS_ERROR";

export const fetchPegawais = (limit = 100, page = 1, search = "") => {
  return async (dispatch) => {
    dispatch({ type: SET_PEGAWAIS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/pegawai?limit=" + limit + "&page=" + page + "&search=" + search);

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_PEGAWAIS,
          data: response?.data?.data,
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PEGAWAIS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data.",
      });
    } finally {
      dispatch({ type: SET_PEGAWAIS_LOADING, status: false });
    }
  };
};

export const fetchPegawaisPublic = (limit = 100, page = 1) => {
  return async (dispatch) => {
    dispatch({ type: SET_PEGAWAIS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/public/pegawai?limit=" + limit + "&page=" + page);

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_PEGAWAIS,
          data: response?.data?.data,
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PEGAWAIS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data.",
      });
    } finally {
      dispatch({ type: SET_PEGAWAIS_LOADING, status: false });
    }
  };
};

export const getPegawaiById = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_PEGAWAIS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/pegawai/" + id);

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_PEGAWAI,
          data: response.data,
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PEGAWAIS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data.",
      });
    } finally {
      dispatch({ type: SET_PEGAWAIS_LOADING, status: false });
    }
  };
};

export const addPegawai = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_PEGAWAIS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.post(`${BASE_URL}/pegawai`, data), {
        loading: "Menyimpan data...",
        success: "Data pegawai berhasil ditambahkan!",
        error: (err) => err?.response?.data?.message || "Gagal menyimpan data!",
      });
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchPegawais());
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PEGAWAIS_ERROR,
        error: error?.message || "Terjadi kesalahan.",
      });
    } finally {
      dispatch({ type: SET_PEGAWAIS_LOADING, status: false });
    }
  };
};

export const updatePegawai = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: SET_PEGAWAIS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.put(`${BASE_URL}/pegawai/${id}`, data), {
        loading: "Mengupdate data...",
        success: "Data pegawai berhasil diupdate!",
        error: (err) => err?.response?.data?.message || "Gagal mengupdate data!",
      });
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchPegawais());
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PEGAWAIS_ERROR,
        error: error?.message || "Terjadi kesalahan.",
      });
    } finally {
      dispatch({ type: SET_PEGAWAIS_LOADING, status: false });
    }
  };
};

export const updatePermissions = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: SET_PEGAWAIS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.put(`${BASE_URL}/pegawai/${id}/pegawai-permissions`, data), {
        loading: "Mengupdate data...",
        success: "Data pegawai berhasil diupdate!",
        error: (err) => err?.response?.data?.message || "Gagal mengupdate data!",
      });
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchPegawais());
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PEGAWAIS_ERROR,
        error: error?.message || "Terjadi kesalahan.",
      });
    } finally {
      dispatch({ type: SET_PEGAWAIS_LOADING, status: false });
    }
  };
};

export const deletePegawai = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_PEGAWAIS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.delete(`${BASE_URL}/pegawai/${id}`), {
        loading: "Menghapus data...",
        success: "Data pegawai berhasil dihapus!",
        error: (err) => err?.response?.data?.message || "Gagal menghapus data!",
      });
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchPegawais());
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PEGAWAIS_ERROR,
        error: error?.message || "Terjadi kesalahan.",
      });
    } finally {
      dispatch({ type: SET_PEGAWAIS_LOADING, status: false });
    }
  };
};
